module.exports = __webpack_public_path__ + "img/janssen.90fa12df.png";